import React from 'react';
import { Box, Chip, Typography, Stack, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { baseColors } from '../../../Themes/colors';
import PillActionButton from '../../../components/buttonComponent/PillActionButton';
var ContentCard = styled(Box, { shouldForwardProp: function (prop) { return prop !== 'dense'; } })(function (_a) {
    var dense = _a.dense;
    return ({
        backgroundColor: baseColors.fullWhite,
        borderRadius: 8,
        overflow: 'hidden',
        padding: dense ? '10px 16px' : '14px 24px',
    });
});
var CardHeader = styled(Box, { shouldForwardProp: function (prop) { return prop !== 'dense'; } })(function (_a) {
    var dense = _a.dense;
    return ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: "1px solid ".concat(baseColors.greyPreset[40]),
        paddingBottom: dense ? 10 : 5,
    });
});
export var DataWrapper = styled(Stack)(function (_a) {
    var theme = _a.theme;
    return ({
        gap: 4,
        minWidth: 0,
        overflow: 'hidden',
        '& .title': {
            fontWeight: 500,
            color: baseColors.greyPreset[5]
        }
    });
});
var CardBody = styled(Box, { shouldForwardProp: function (prop) { return prop !== 'dense'; } })(function (_a) {
    var dense = _a.dense;
    return ({
        padding: dense ? '10px 0px' : '16px 0px',
    });
});
var SectionIconBadge = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: baseColors.greyPreset[55],
    flexShrink: 0,
    '& svg': { width: 18, height: 18 },
});
var TabSectionCard = function (_a) {
    var title = _a.title, sectionIcon = _a.sectionIcon, titleIcon = _a.titleIcon, chip = _a.chip, _b = _a.showEditIcon, showEditIcon = _b === void 0 ? false : _b, onEditClick = _a.onEditClick, _c = _a.showSaveCancel, showSaveCancel = _c === void 0 ? false : _c, onSave = _a.onSave, onCancel = _a.onCancel, _d = _a.isSaveDisabled, isSaveDisabled = _d === void 0 ? false : _d, headerActions = _a.headerActions, children = _a.children, _e = _a.dense, dense = _e === void 0 ? false : _e;
    return (React.createElement(ContentCard, { dense: dense },
        React.createElement(CardHeader, { dense: dense },
            React.createElement(Stack, { direction: "row", alignItems: "center", gap: 1 },
                sectionIcon && React.createElement(SectionIconBadge, null, sectionIcon),
                title && (React.createElement(Typography, { variant: "h6", color: baseColors.bluePreset[10] }, title)),
                titleIcon,
                chip && (React.createElement(Chip, { label: chip, size: "small", sx: { fontWeight: 400, backgroundColor: '#d3e3fd' } }))),
            React.createElement(Stack, { direction: "row", alignItems: "center", gap: 2 },
                headerActions,
                showSaveCancel && (React.createElement(React.Fragment, null,
                    React.createElement(Button, { variant: "outlined", size: "small", onClick: onCancel, sx: {
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: 12,
                            borderColor: baseColors.greyPreset[20],
                            color: baseColors.greyPreset[10],
                            '&:hover': { borderColor: baseColors.greyPreset[10] },
                        } }, "Cancel"),
                    React.createElement(Button, { variant: "contained", size: "small", onClick: onSave, disabled: isSaveDisabled, sx: {
                            textTransform: 'none',
                            fontWeight: 600,
                            fontSize: 12,
                            backgroundColor: baseColors.successPreset[30],
                            '&:hover': { backgroundColor: baseColors.successPreset[10] },
                            '&.Mui-disabled': { opacity: 0.5 },
                        } }, "Save"))),
                showEditIcon && !showSaveCancel && (React.createElement(PillActionButton, { icon: React.createElement("span", { className: "icon-Edit" }), label: "Edit", onClick: onEditClick, hoverOnly: true, padding: '4px', bgColor: baseColors.greyPreset[55], borderColor: baseColors.darkPreset[10], textColor: baseColors.darkPreset[10] })))),
        React.createElement(CardBody, { dense: dense }, children)));
};
export default TabSectionCard;
